import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Stars from "react-stars";
import { reject, isNil } from "ramda";
import { Name, InsiderPhoto, GroupName, Tags } from "./";
import * as mixpanel from "core/integrations/mixpanel";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import { candidate } from "routes/paths";

const Wrap = styled(Link)`
  margin-bottom: 1rem;
  min-height: 182px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Title = styled.div`
  font-family: "CircularStd-Bold", sans-serif;
  font-size: 21px;
`;
const Reviews = styled.div`
  font-family: "CircularStd-Book", sans-serif;
  font-size: 16px;
  color: #d8d8d8;
`;
export default ({
  truncate,
  content,
  backLink = candidate.main,
  insider: {
    id,
    company,
    title,
    display_name,
    resume_truncated,
    resume,
    suggested,
    slug,
    reviews,
    company_logo,
    major_studied,
    tags,
    rate: { value, number_of_reviews },
    has_availability,
    group_tag,
    call_price: { current, original }
  }
}) => {
  return (
    <Wrap
      className="flex flex-row-ns flex-column pa4 br2 bg-white items-center black no-underline"
      to={`/insiders/${id}/book?backLink=${backLink}`}
      onClick={() => {
        fbPixel.fbq("trackCustom", "ViewInsiderProfile");
        dataLayer.push({
          event: "ViewInsiderProfile"
        });
        return mixpanel.trackEvent("view an insider profile", { insider: id });
      }}
    >
      <div className="mr3 flex-shrink-0 w3 w4-ns db-ns dn">
        <InsiderPhoto
          photo={
            company.logo ||
            "https://storage.googleapis.com/thelobby-public-storage/insiders/photo/TheLobby_Logo-02.jpg"
          }
          alt={display_name || slug}
        />
      </div>
      <div className="dn-ns flex items-center justify-between w-100 mb3">
        <div className="flex-shrink-0">
          <InsiderPhoto photo={company.logo} alt={display_name || slug} />
        </div>
        <div className="tr flex-shrink-0">
          <div className="flex justify-center">
            <Stars
              count={5}
              size={25}
              value={value}
              edit={false}
              color2={"#F76367"}
            />
          </div>
          <Reviews>
            {number_of_reviews === 1
              ? "1 review"
              : `${number_of_reviews} Reviews`}
          </Reviews>
        </div>
      </div>
      <div className="flex-auto tl">
        <Title>
          <Name {...{ display_name, title, company, current }} />
        </Title>
        {tags &&
          tags.group_tag && <GroupName>{tags.group_tag.label} </GroupName>}
        {tags && <Tags items={reject(isNil, tags)} />}
      </div>
      <div className="ml3  tc flex-shrink-0 db-ns dn">
        <div className=" mr4 flex justify-center">
          <Stars
            count={5}
            size={25}
            value={value}
            edit={false}
            color2={"#F76367"}
          />
        </div>
        <Reviews>
          {number_of_reviews === 1
            ? "1 review"
            : `${number_of_reviews} Reviews`}
        </Reviews>
      </div>
    </Wrap>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/candidate/Insider.js